export const CHAT_DEFAULT_WIDTH = 405;
export const LG_EXTENDED_WIDTH = 1685;
